import { login, getInfo, logout } from '@/api'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: {},
  roles: [],
  permissions: [],
  menus: [],
  isSuper: false,
  infoLoaded: false
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info && typeof info === 'object' ? { ...info } : {}
  },
  SET_ROLES(state, roles) {
    state.roles = Array.isArray(roles) ? roles.map(r => String(r)) : []
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = Array.isArray(permissions) ? permissions.map(p => String(p)) : []
  },
  SET_MENUS(state) {
    // 侧栏用 permission.routes，API menus 不再入 store，避免无用深树
    state.menus = []
  },
  SET_IS_SUPER(state, val) {
    state.isSuper = !!val
  },
  SET_INFO_LOADED(state, loaded) {
    state.infoLoaded = !!loaded
  }
}

let clearing = false

function resetDynamicRouter() {
  try {
    // eslint-disable-next-line global-require
    const routerMod = require('@/router')
    if (routerMod && typeof routerMod.resetRouter === 'function') routerMod.resetRouter()
    // eslint-disable-next-line global-require
    const permMod = require('@/permission')
    if (permMod && typeof permMod.resetPermissionGuard === 'function') {
      permMod.resetPermissionGuard()
    }
  } catch (e) { /* ignore */ }
}

function clearAuthState(commit) {
  if (clearing) return
  clearing = true
  try {
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', {})
    commit('SET_ROLES', [])
    commit('SET_PERMISSIONS', [])
    commit('SET_MENUS', [])
    commit('SET_IS_SUPER', false)
    commit('SET_INFO_LOADED', false)
    removeToken()
    commit('permission/RESET_ROUTES', null, { root: true })
    commit('tagsView/DEL_ALL_VISITED_VIEWS', null, { root: true })
    commit('tagsView/DEL_ALL_CACHED_VIEWS', null, { root: true })
    resetDynamicRouter()
  } finally {
    clearing = false
  }
}

const actions = {
  login({ commit }, userInfo) {
    const username = (userInfo.username || '').trim()
    const password = userInfo.password || ''
    return login({ username, password }).then(res => {
      const { token } = res.data || {}
      if (!token) {
        return Promise.reject(new Error('登录成功但未返回 token'))
      }
      commit('permission/RESET_ROUTES', null, { root: true })
      commit('tagsView/DEL_ALL_VISITED_VIEWS', null, { root: true })
      commit('tagsView/DEL_ALL_CACHED_VIEWS', null, { root: true })
      resetDynamicRouter()
      commit('SET_TOKEN', token)
      commit('SET_INFO_LOADED', false)
      commit('SET_IS_SUPER', false)
      commit('SET_ROLES', [])
      commit('SET_PERMISSIONS', [])
      commit('SET_MENUS')
      setToken(token)
    })
  },

  getInfo({ commit }) {
    return getInfo().then(res => {
      const data = res.data || {}
      const roleList = Array.isArray(data.roles) ? data.roles : []
      const info = data.userInfo || {}
      const perms = Array.isArray(data.permissions) ? data.permissions : []
      const superFlag = !!data.is_super
        || roleList.includes('super_admin')
        || Number(info.id) === 1
        || info.username === 'admin'
      commit('SET_USER_INFO', info)
      commit('SET_ROLES', roleList)
      commit('SET_PERMISSIONS', perms)
      commit('SET_MENUS')
      commit('SET_IS_SUPER', superFlag)
      commit('SET_INFO_LOADED', true)
      return data
    })
  },

  logout({ commit }) {
    return logout().finally(() => {
      clearAuthState(commit)
    })
  },

  resetToken({ commit }) {
    clearAuthState(commit)
    return Promise.resolve()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
